export default __webpack_public_path__ + "static/media/flag-it.a31ddc83.svg";